/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BootstrapRequest } from '../models/BootstrapRequest';
import type { BootstrapResponse } from '../models/BootstrapResponse';
import type { LoginRequest } from '../models/LoginRequest';
import type { LoginResponse } from '../models/LoginResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthSessionControllerService {
    /**
     * @param xTenantId
     * @returns string OK
     * @throws ApiError
     */
    public static refresh(
        xTenantId: string,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/refresh',
            headers: {
                'X-Tenant-ID': xTenantId,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static logout(): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/logout',
        });
    }
    /**
     * @param xTenantId
     * @param requestBody
     * @returns LoginResponse OK
     * @throws ApiError
     */
    public static login(
        xTenantId: string,
        requestBody: LoginRequest,
    ): CancelablePromise<LoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/login',
            headers: {
                'X-Tenant-ID': xTenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns BootstrapResponse OK
     * @throws ApiError
     */
    public static bootstrap(
        requestBody: BootstrapRequest,
    ): CancelablePromise<BootstrapResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/bootstrap',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
